import { useEffect, useState } from "react";
import { SelectInputWithoutForm } from "../../../components/form/select-input";
import ModalPageFooter from "../../../components/global-layout/modal-page-footer";
import { toLocalInputValue } from "../../../utils/common";
import Skeleton from "react-loading-skeleton";

function OpenExcelModalForm({
  handleExcelModal,
  isLoading,
  magicDataOption,
  setExcelDownloadData,
  handleDownloadReport,
  isExcelLoading,
  excelDownloadData
}: any) {
  const [startDate, setStartDate] = useState<any>("");
  const [endDate, setEndDate] = useState<any>("");
  const [errors, setErrors] = useState({
    reportType: "",
    magicType:""
  });
  const reportsOptions = [
    { id: "1", value: "Input Report" },
    { id: "2", value: "Output Report" },
    { id: "3", value: "Daily Annotation Report" },
  ];
  useEffect(() => {
    const now = new Date();
    let startLocal = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      6,
      0,
      0
    );
    if (now < startLocal) {
      startLocal = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() - 1,
        6,
        0,
        0
      );
    }
    const endLocal = new Date(startLocal.getTime() + 24 * 60 * 60 * 1000);
    setStartDate(toLocalInputValue(startLocal));
    setEndDate(toLocalInputValue(endLocal));
    setExcelDownloadData((prev: any) => ({
      ...prev,
      startDate: startLocal,
      endDate: endLocal,
    }));
  }, []);
  const handleSubmit = () => {
    setErrors({
      reportType: "",
      magicType: "",
    });
  if (!excelDownloadData.reportType) {
    setErrors((prev) => ({
      ...prev,
      reportType: "Please select a report type",
    }));
  } else if (!excelDownloadData.magicId) {
    setErrors((prev) => ({
      ...prev,
      magicType: "Please select a magic type",
    }));
  } else {
    setErrors({
      reportType: "",
      magicType: "",
    });
    handleDownloadReport();
  }
};

const formatDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};


useEffect(() => {
  const now = new Date();
  // today
  const startLocal = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  // tomorrow
  const endLocal = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + 1
  );
  const formattedStartDate = formatDate(startLocal);
  const formattedEndDate = formatDate(endLocal);

  setStartDate(formattedStartDate);
  setEndDate(formattedEndDate);

  setExcelDownloadData((prev: any) => ({
    ...prev,
    startDate: formattedStartDate,
    endDate: formattedEndDate,
  }));
}, []);


  return (
    <div className="w-full h-full flex flex-col">
      <div className="w-full flex-auto basis-0 pr-2 overflow-y-auto scrollbar-large">
        <div className="w-[100%] h-auto">
          <div className="w-full h-auto flex justify-between items-start pt-4">
            <div className="w-[100%] ">
              <div className="mb-[3.8rem]">
                {isExcelLoading ? (
                  <>
                    <Skeleton width="100%" height={47} borderRadius={3} />
                    <Skeleton width="100%" height={47} borderRadius={3} />
                    <Skeleton width="100%" height={47} borderRadius={3} />
                  </>
                ) : (
                  <>
                    <div className="grid grid-cols-2 items-center gap-4 mb-[1rem]">
                      <h1 className="text-[1.5rem]">From</h1>
                      <h1 className="text-[1.5rem]">To</h1>
                    </div>
                    <div className="grid grid-cols-2 items-center gap-4 mb-[3rem]">
                      <input
                        type="date"
                        id="responseStartDateTime"
                        className="w-full h-auto text-[1.6rem] font-inter font-normal text-io-black bg-io-white border p-[1rem] rounded-[5px]"
                        value={startDate}
                        onChange={(e) => {
                          const value = e.target.value;
                          setExcelDownloadData((prev: any) => ({
                            ...prev,
                            startDate: value,
                          }));
                          setStartDate(value);
                        }}
                      />

                      <input
                        type="date"
                        id="responseEndDateTime"
                        className="w-full h-auto text-[1.6rem] font-inter font-normal text-io-black bg-io-white border p-[1rem] rounded-[5px]"
                        value={endDate}
                        onChange={(e) => {
                          const value = e.target.value;
                          setExcelDownloadData((prev: any) => ({
                            ...prev,
                            endDate: value,
                          }));
                          setEndDate(value);
                        }}
                      />
                    </div>

                    <div className="mb-[3rem]">
                      <SelectInputWithoutForm
                        labelName={"Report type"}
                        id={"reportType"}
                        isRequired={true}
                        options={reportsOptions}
                        getOptionLabel={(option: any) => option.value}
                        getOptionValue={(option: any) => option.id}
                        error={errors.reportType}
                        getSelection={(data: any) =>
                          setExcelDownloadData((prev: any) => ({
                            ...prev,
                            reportType: data.id,
                          }))
                        }
                      />
                    </div>
                    <div className="mb-[3rem]">
                      <SelectInputWithoutForm
                        labelName={"Magic"}
                        id={"magic"}
                        isRequired={true}
                        options={magicDataOption}
                        getOptionLabel={(option: any) => option.value}
                        getOptionValue={(option: any) => option.id}
                        error={errors.magicType}
                        getSelection={(data: any) =>
                          setExcelDownloadData((prev: any) => ({
                            ...prev,
                            magicId: data.id,
                            magicName: data.value,
                          }))
                        }
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalPageFooter
        footerType="onlyDownloadButtonWithSpinLoader"
        handleCancel={handleExcelModal}
        handleSubmit={handleSubmit}
        isLoading={isExcelLoading}
        buttonText={"Download"}
      />
    </div>
  );
}

export default OpenExcelModalForm;
